'use strict';

(function () {
  'use strict';

  angular.module('msActivities').controller('ActivityUserResponseCtrl', ActivityUserResponseCtrl);

  ActivityUserResponseCtrl.$inject = ['$log', '$scope', '$translate', 'widgetSvc', 'responseId', 'activityResponse', 'status', 'activitySvc', 'activityResponseSvc', 'NotifyingSvc', 'activityRouter'];

  /* @ngInject */
  function ActivityUserResponseCtrl($log, $scope, $translate, widgetSvc, responseId, activityResponse, status, activitySvc, activityResponseSvc, NotifyingSvc, activityRouter) {
    var vm = this;
    vm.title = 'ActivityUserResponseCtrl';
    activate();

    ////////////////

    // This function is necessary to be in scope to get the user_response widget to work
    $scope.findResponse = function (widgetUuid) {
      var widget = widgetSvc.getByUuid(activityResponse, widgetUuid);
      return !widget ? '' : widget.response;
    };

    function activate() {
      $log.debug('ActivityResponse control activate');
      $scope.isResponse = true;
      vm.responseId = responseId;
      vm.activity = activityResponse;
      vm.sharedState = status;
      vm.updateSharedState = _updateSharedState;
      vm.viewResponse = _viewResponse;

      activityResponseSvc.getResponses(vm.activity.url).then(function (data) {
        for (var i in data) {
          if (vm.activity.url === data[i].activity.url) {
            vm.responses = data[i].responses;
          }
        }

        if (vm.responses) {
          vm.responses = _.orderBy(vm.responses, ['modifiedOn'], ['desc']);
          // Set initial history dropdown selection to be the response id from the url
          vm.selectedResponse = _.find(vm.responses, function (r) {
            return r.id.toString() === responseId;
          });
        }
      });

      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.PAGE_TITLE, {
        pageTitle: $translate.instant('pageTitles.activityResponseLeader') + activityResponse.title
      });
    }

    vm.startTrain = function () {
      activityRouter.createTrain(vm.activity);
    };
    /////////////////////////////////
    /**
     * Find a Widget response, if available, for the given widget uuid.
     * @param widgetUuid - uuid of the widget to find.
     * @returns {string}
     * @private
     */
    vm.findResponse = function (widgetUuid) {
      var widget = widgetSvc.getByUuid(vm.activity, widgetUuid);
      return !widget ? '' : widget.response;
    };
    /**
     * Update this activity response with the given shared state
     * @param activityResponse - The activity response to update
     * @param shared - The new shared state
     * @private
     */
    function _updateSharedState(shared) {
      activitySvc.updateActivityStatus(vm.responseId, shared).then(function (dat) {
        vm.sharedState = dat.data;
      });
    }

    function _viewResponse() {
      if (vm.selectedResponse) {
        activityRouter.showHistory({
          response: vm.selectedResponse.id
        });
      }
    }
  }
})();